import { useEffect, useState } from "react";
import { get } from "@/lib/api";
import { FileText, BarChart3, ShieldAlert, CalendarClock } from "lucide-react";
import { ReportBuilder } from "@/components/desk/ReportBuilder";

export function EvidenceReports() {
  const [e, setE] = useState(null);
  useEffect(() => { get("/desk/evidence").then(setE); }, []);
  if (!e) return null;
  const ar = e.annual_report;
  const b = e.baseline;
  return (
    <div className="space-y-6" data-testid="evidence-reports">
      <ReportBuilder />
      {ar && (
        <div className="rounded-2xl border border-stone-200 bg-white p-6" data-testid="annual-report">
          <div className="flex items-center gap-2"><FileText className="h-5 w-5 text-mill-moss" /><h3 className="font-display text-lg font-semibold text-mill-ink">{ar.title}</h3></div>
          <p className="mt-1 text-sm text-mill-muted">Strategic and evidence baseline — a historic approved document, not a live operational policy.</p>
          <dl className="mt-4 grid grid-cols-2 gap-3 text-sm sm:grid-cols-4">
            <div><dt className="text-[10px] uppercase tracking-wider text-mill-muted">Owner</dt><dd className="text-mill-ink">{ar.owner}</dd></div>
            <div><dt className="text-[10px] uppercase tracking-wider text-mill-muted">Status</dt><dd className="text-mill-ink">Approved historic baseline</dd></div>
            <div><dt className="text-[10px] uppercase tracking-wider text-mill-muted">Published</dt><dd className="text-mill-ink">{ar.published_date}</dd></div>
            <div><dt className="text-[10px] uppercase tracking-wider text-mill-muted">Next cycle</dt><dd className="text-mill-ink">Annual</dd></div>
          </dl>
        </div>
      )}

      <div className="rounded-2xl border border-stone-200 bg-white p-6" data-testid="evidence-baseline">
        <div className="flex items-center gap-2"><BarChart3 className="h-5 w-5 text-mill-moss" /><h3 className="font-display text-lg font-semibold text-mill-ink">Evidence for trustees & Prove and Improve</h3></div>
        <div className="mt-4 grid grid-cols-2 gap-3 sm:grid-cols-3">
          <Tile n={b.activities} label="Activities" />
          <Tile n={b.volunteers_active} label="Active volunteers" />
          <Tile n={b.room_bookings_ytd} label="Room bookings (YTD)" />
        </div>
        <p className="mt-3 text-xs text-mill-muted">{b.impact_narrative} {b.fundraising_note}</p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <div className="rounded-2xl border border-stone-200 bg-white p-5" data-testid="evidence-restricted">
          <div className="flex items-center gap-2"><ShieldAlert className="h-4 w-4 text-[#B45309]" /><h4 className="font-display text-base font-semibold text-mill-ink">Restricted cases</h4></div>
          <p className="mt-2 rounded-lg bg-[#FEF2F2] px-3 py-2 text-[11px] text-[#991B1B]">Counts only — no case content in this desk. Dedicated restricted workflow and permissions required (future governance decision).</p>
        </div>
        <div className="rounded-2xl border border-stone-200 bg-white p-5" data-testid="evidence-dates">
          <div className="flex items-center gap-2"><CalendarClock className="h-4 w-4 text-mill-moss" /><h4 className="font-display text-base font-semibold text-mill-ink">Reporting dates</h4></div>
          <ul className="mt-3 space-y-2 text-sm">
            <li className="flex justify-between"><span className="text-mill-ink">Next trustee review</span><span className="text-mill-muted">{e.next_trustee_review}</span></li>
            <li className="flex justify-between"><span className="text-mill-ink">Prove & Improve discussion</span><span className="text-mill-muted">{e.next_prove_improve}</span></li>
          </ul>
        </div>
      </div>
    </div>
  );
}

function Tile({ n, label }) {
  return <div className="rounded-xl bg-mill-alt/50 p-4 text-center"><p className="font-display text-2xl font-bold text-mill-ink">{n}</p><p className="text-xs text-mill-muted">{label}</p></div>;
}
